<div class="gallery-container">
{{productDetailHeight}}
    <div class="product-gallery__featured">
        <owl-carousel-o [options]="{items: 1, dots:false, margin:8, autoWidth: autoWidth}" #owlCar>
            <ng-container *ngFor="let image of imageList; index as j">
                <ng-template carouselSlide [id]="j" [width]="imageSize">
                    <div
                        *ngIf="!image.includes('medicineimages')&&!image.includes('http')&&!image.includes('commonimages')">
                        <img  [ngStyle.gt-sm]
                        ="{height:productDetailHeight,width
                          :productDetailWidth}" [alt]="name" class="imgH collection-banner" [src]="bigImage+image | safe: 'resourceUrl'"
                            onerror="this.src='assets/images/products/noImage/no-image.png';" alt="">
                    </div>

                    <ng-container *ngIf="image.includes('http')">
                        <ng-container>
                            <img [alt]="name" class="imgH collection-banner" [src]="image| safe: 'resourceUrl'"
                                onerror="this.src='assets/images/products/noImage/no-image.png';" alt="">
                        </ng-container>
                    </ng-container>

                    <ng-container *ngIf="image.includes('commonimages')">
                        <img [alt]="name" class="imgH collection-banner" [src]="serverPath7+image| safe: 'resourceUrl'"
                            onerror="this.src='assets/images/products/noImage/no-image.png';" alt="">
                    </ng-container>
                </ng-template>
            </ng-container>
        </owl-carousel-o>
    </div>

    <div class="product-gallery__carousel">
        <owl-carousel-o [options]="{items:3, dots:false, margin:10, autoWidth: true}">
            <ng-container *ngFor="let image of imageList; index as i">
                <ng-template carouselSlide [id]="i" [width]="100">
                    <a (click)="owlCar.to(i); changeimage(i)">
                        <div *ngIf="!image.includes('medicineimages')&&!image.includes('http')&&!image.includes('commonimages')"
                            [class.active]="i == activeSlide">
                            <img [src]="bigImage+image | safe: 'resourceUrl'"
                                [ngClass]="{'product-gallery__carousel-item--active':selectedImage === i || (i == 0 && !selectedImage)}">
                        </div>

                        <!-- <div *ngIf="!image.includes('medicineimages')&&!image.includes('http')&&!image.includes('commonimages')"
                            class="owl-thumb" [class.active]="i == activeSlide">
                            <img [src]="bigImage+image | safe: 'resourceUrl'" [alt]="image.alt" class="img-fluid"
                                (click)="owlCar.to(activeSlide = i.toString())">
                        </div>
                        <div *ngIf="image.includes('http')" class="owl-thumb" [class.active]="i == activeSlide">
                            <img [src]="image| safe: 'resourceUrl'" [alt]="image.alt" class="img-fluid"
                                (click)="owlCar.to(activeSlide = i.toString())">
                        </div>
                        <div *ngIf="image.includes('commonimages')" class="owl-thumb" [class.active]="i == activeSlide">
                            <img [src]="serverPath7+image| safe: 'resourceUrl'" [alt]="image.alt" class="img-fluid"
                                (click)="owlCar.to(activeSlide = i.toString())">
                        </div> -->
                    </a>
                </ng-template>
            </ng-container>
        </owl-carousel-o>
    </div>
</div>